import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 1.334v1.333m0 10.667v1.333M2.667 8H1.333M4.21 4.21l-.942-.943m8.524.943.942-.943M4.21 11.794l-.942.942m8.524-.943.942.943M14.667 8h-1.334m-2 0a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }